import React from 'react';
import './PrivacyPolicy.css';
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import {RouteName} from "../constants/RouteName";
import {Trans, useTranslation} from "react-i18next";

function PrivacyPolicy() {
    const {t} = useTranslation();

    // Content is injected at runtime by <Trans>, so the anchors are intentionally empty here.
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    const mail = <a href="mailto:inklog@severin-hanke.de"/>;
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    const legalNotice = <a href={RouteName.legalNotice}/>;

    return (
        <div className='page' id='privacy-policy'>
            <Header/>
            <h2>{t('privacyPolicy')}</h2>
            <p>{t('pp_lastUpdated')}</p>

            <p><Trans i18nKey='pp_intro1'/></p>
            <p>{t('pp_intro2')}</p>

            <section>
                <h2>{t('pp_s1_title')}</h2>
                <p>{t('pp_s1_p1')}</p>
                <p><Trans i18nKey='pp_s1_responsible' components={{mail}}/></p>
                <p><Trans i18nKey='pp_s1_p2' components={{legalNotice}}/></p>
                <p>{t('pp_s1_p3')}</p>
            </section>

            <section>
                <h2>{t('pp_s2_title')}</h2>
                <p><Trans i18nKey='pp_s2_p1'/></p>
                <ul>
                    <li><Trans i18nKey='pp_s2_li1'/></li>
                    <li><Trans i18nKey='pp_s2_li2'/></li>
                    <li><Trans i18nKey='pp_s2_li3'/></li>
                </ul>
                <p>{t('pp_s2_p2')}</p>
            </section>

            <section>
                <h2>{t('pp_s3_title')}</h2>

                <h3>{t('pp_s3_1_title')}</h3>
                <p><Trans i18nKey='pp_s3_1_p1'/></p>
                <p><Trans i18nKey='pp_s3_1_p2'/></p>
                <p>{t('pp_s3_1_p3')}</p>
                <ul>
                    <li>{t('pp_s3_1_li1')}</li>
                    <li>{t('pp_s3_1_li2')}</li>
                    <li>{t('pp_s3_1_li3')}</li>
                    <li>{t('pp_s3_1_li4')}</li>
                    <li>{t('pp_s3_1_li5')}</li>
                </ul>
                <p><Trans i18nKey='pp_s3_1_p4'/></p>

                <h3>{t('pp_s3_2_title')}</h3>
                <p><Trans i18nKey='pp_s3_2_p1'/></p>

                <h3>{t('pp_s3_3_title')}</h3>
                <p>{t('pp_s3_3_p1')}</p>

                <h3>{t('pp_s3_4_title')}</h3>
                <p>{t('pp_s3_4_p1')}</p>
                <p><Trans i18nKey='pp_s3_4_provider'/></p>
                <p><Trans i18nKey='pp_s3_4_p2'/></p>

                <h3>{t('pp_s3_5_title')}</h3>
                <p>{t('pp_s3_5_p1')}</p>
            </section>

            <section>
                <h2>{t('pp_s4_title')}</h2>
                <p><Trans i18nKey='pp_s4_p1'/></p>
                <p>{t('pp_s4_p2')}</p>
                <ul>
                    <li><Trans i18nKey='pp_s4_li1'/></li>
                    <li><Trans i18nKey='pp_s4_li2'/></li>
                </ul>
                <p>{t('pp_s4_p3')}</p>
            </section>

            <section>
                <h2>{t('pp_s5_title')}</h2>
                <p>{t('pp_s5_p1')}</p>
                <p><Trans i18nKey='pp_s5_p2'/></p>
            </section>

            <section>
                <h2>{t('pp_s6_title')}</h2>
                <p>{t('pp_s6_p1')}</p>
            </section>

            <section>
                <h2>{t('pp_s7_title')}</h2>
                <p><Trans i18nKey='pp_s7_p1'/></p>
            </section>

            <section>
                <h2>{t('pp_s8_title')}</h2>
                <p>{t('pp_s8_p1')}</p>
                <ul>
                    <li><Trans i18nKey='pp_s8_li1'/></li>
                    <li><Trans i18nKey='pp_s8_li2'/></li>
                    <li><Trans i18nKey='pp_s8_li3'/></li>
                    <li><Trans i18nKey='pp_s8_li4'/></li>
                    <li><Trans i18nKey='pp_s8_li5'/></li>
                    <li><Trans i18nKey='pp_s8_li6'/></li>
                    <li><Trans i18nKey='pp_s8_li7'/></li>
                </ul>
                <p><Trans i18nKey='pp_s8_p2' components={{mail}}/></p>

                <h3>{t('pp_s8_complaint_title')}</h3>
                <p>{t('pp_s8_p3')}</p>
            </section>

            <section>
                <h2>{t('pp_s9_title')}</h2>
                <p>{t('pp_s9_p1')}</p>
            </section>

            <section>
                <h2>{t('pp_s10_title')}</h2>
                <p>{t('pp_s10_p1')}</p>
            </section>

            <section>
                <h2>{t('pp_s11_title')}</h2>
                <p><Trans i18nKey='pp_s11_p1' components={{mail}}/></p>
            </section>

            <section>
                <h2>{t('pp_s12_title')}</h2>
                <p>{t('pp_s12_p1')}</p>
            </section>

            <section>
                <h2>{t('pp_s13_title')}</h2>
                <p>{t('pp_s13_p1')}</p>
                <p><Trans i18nKey='pp_s13_p2' components={{mail}}/></p>
            </section>
            <Footer/>
        </div>
    );
}

export default PrivacyPolicy;
